import { Logic } from '~common/ui-logic/logic'
import type { AppContextType } from '~/app-context'
import type { PersistedImportState } from '~/features/email-importer/services/types'

export interface ImportProgressBarLogicDependencies {}

export interface ImportProgressBarLogicState {
    showConfirmReset: boolean
}

export class ImportProgressBarLogic extends Logic<
    ImportProgressBarLogicDependencies & AppContextType,
    ImportProgressBarLogicState
> {
    getInitialState = (): ImportProgressBarLogicState => ({
        showConfirmReset: false,
    })

    async initialize() {
        const fullState = this.deps.services.cache.getKey(
            'importProgress',
        ) as PersistedImportState | null
        if (
            fullState &&
            (fullState.status.import === 'running' ||
                fullState.status.scan === 'running')
        ) {
            await this.deps.services.importer.pause()
        }
    }

    pause = async () => {
        await this.deps.services.importer.pause()
    }

    reset = async () => {
        await Promise.all([
            this.deps.services.importer.reset(),
            this.deps.services.invoiceProcessor.invoiceProcessingQueue.clear(),
        ])
        this.deps.services.invoiceProcessor.invoiceProcessingQueue.stop()
    }

    resume = async () => {
        await this.deps.services.importer.start()
        const processor = this.deps.services.invoiceProcessor
        const queueEmpty = processor.invoiceProcessingQueue.isQueueEmpty()
        if (queueEmpty) {
            await processor.scheduleExistingInvoices()
        } else {
            processor.resumeQueue()
        }
    }

    showConfirmReset = () => {
        this.setState({ showConfirmReset: true })
    }

    hideConfirmReset = () => {
        this.setState({ showConfirmReset: false })
    }

    handleResetConfirm = async () => {
        await this.reset()
        this.hideConfirmReset()
    }
}
